import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import {Tag} from 'antd';

/**
 * 
 * @param {object} props
 * @param {string} props.title
 * @param {array} props.list - simple array ["", ""] 
 * @param {string} props.color - tag color, antd tag API
 */
const CustomTagList = (props) => {
  // console.log(props);
  return (
    <div css={css`
      background-color: #ecf6fd;
      border-radius: 5px;
      padding: 10px 0;
      margin: 10px 0;
    `}>
      <div css={css`
        padding: 10px;
        margin: 5px;
      `}>{props.title}</div>
      <div css={css`
        padding: 10px;
        margin: 5px;
      `}>
      {
        props.list.map((value)=>
        <Tag style={{marginTop: 5,}} color={props.color} key={value}>{value}</Tag>)
      }  
      </div>
    </div>
  )
}

export default CustomTagList;

CustomTagList.defaultProps = {
  title: "",
  color: "",
  list: []
}